import axios from "axios";

export function updatePickedUpTicket(e: any) {
  if (!e) throw new Error("Required parameter for shimpment status update.");
  const body = { locker_response: e };
  return axios.patch("https://api.skroutzdelivery.gr/external/swipBoxWebBluetooth/syncData", body);
}
